<template>
  <div>
    <!-- 加盟店申込（アフィリエイト） -->
    <div
      class="
        p-menu-merchant-application__contents
        p-menu-merchant-application__contents-affiliate
      "
    >
      <div class="p-menu-merchant-application__contents__left">
        <div class="p-menu-merchant-application__shopping-guide">
          本プランは外部サービスへのお申込みとなります。
          <a
            @click="clickShoppingGuide"
            class="p-menu-merchant-application__shopping-guide--link"
          >
            ショッピングガイド
          </a>
          をご確認のうえ、サービス提供企業へ直接お申込みください。
        </div>

        <div class="p-menu-merchant-application__coupon-code">
          <p
            v-if="getCouponCodeTitle"
            class="p-menu-merchant-application__coupon-code--title"
          >
            {{ getCouponCodeTitle }}
          </p>
          <div
            v-if="getCouponCode"
            class="p-menu-merchant-application__coupon-code__code-area"
          >
            <p
              class="p-menu-merchant-application__coupon-code__code-area--label"
            >
              {{ getCouponCode }}
            </p>
            <div
              class="p-menu-merchant-application__coupon-code__code-area--btn"
            >
              <a
                class="c-button__tertiary"
                @click.prevent="clickCouponCodeBtn()"
                href="javascript:;"
                >クーポンコードをコピー</a
              >
            </div>
          </div>
          <p
            v-if="getCouponCodeDescription"
            class="p-menu-merchant-application__coupon-code--description"
          >
            {{ getCouponCodeDescription }}
          </p>
        </div>
      </div>

      <div class="p-menu-merchant-application__contents__right">
        <div class="c-buttonWrap2">
          <a
            class="c-button c-button__primary c-button__primary--color2"
            :class="{
              'c-button__primary--inactive':
                planData.applFlag === CONST.APPL_FLG.STOP,
            }"
            @click="clickWebApplyBtn()"
            :disabled="planData.applFlag === CONST.APPL_FLG.STOP"
            >申し込む</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import constData from "@/mixins/const/constData";

export default {
  props: {
    planData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isError: false
    };
  },
  computed: {
    getCouponCodeTitle() {
      if (
        this.planData.usageDetailLife &&
        this.planData.usageDetailLife.affiliateCoupons
      ) {
        return this.planData.usageDetailLife.affiliateCoupons[0].couponCodeNm;
      }
      return "";
    },
    getCouponCode() {
      if (
        this.planData.usageDetailLife &&
        this.planData.usageDetailLife.affiliateCoupons
      ) {
        return this.planData.usageDetailLife.affiliateCoupons[0].couponCd;
      }
      return "";
    },
    getCouponCodeDescription() {
      if (
        this.planData.usageDetailLife &&
        this.planData.usageDetailLife.affiliateCoupons
      ) {
        return this.planData.usageDetailLife.affiliateCoupons[0]
          .couponCdExplanation;
      }
      return "";
    }
  },
  methods: {
    clickShoppingGuide() {
      this.$scrollTo("#p-menus-no-plan-detail_shopping-guide");
    },
    clickCouponCodeBtn() {
      this.$copy.CopyToClipboard(this.getCouponCode);
    },
    clickWebApplyBtn() {
      this.$emit("apply");
    }
  }
};
</script>

<style lang="scss" scoped></style>
